import { Virtuoso } from 'react-virtuoso';

import Styles from './index.module.scss';

import type { ChartWidget } from '../ChartWidget';
import type { ComponentProps } from 'react';

export interface Props<T> {
	data: T[];
	renderItem: (item: T) => React.ReactNode;
}

export const ChartWidgetList = <T,>({ data, renderItem }: Props<T>) => {
	return (
		<Virtuoso
			horizontalDirection
			data={data}
			className={Styles.container}
			itemContent={(_, item) => {
				return <div className={Styles.border}>{renderItem(item)}</div>;
			}}
		/>
	);
};

export const WithListItemStyle = (
	Component: React.ComponentType<ComponentProps<typeof ChartWidget>>
) => {
	return <T,>(props: ComponentProps<typeof ChartWidget<T>>) => {
		return (
			<Component
				headerStyle={{ fontSize: 20 }}
				chartStyle={{
					paddingTop: 16,
					paddingBottom: 8,
				}}
				{...props}
			>
				{(result) => (
					<div
						style={{
							flex: 1,
							display: 'flex',
							alignItems: 'center',
						}}
					>
						{props.children ? props.children(result as NonNullable<T>) : null}
					</div>
				)}
			</Component>
		);
	};
};
